export const DIA_CHI_LAY_HANG_PERMISSION_CODES = {
  WEB_BH_DIA_CHI_LAY_HANG_LIST: 'WEB_BH_DIA_CHI_LAY_HANG_LIST',
  WEB_BH_DIA_CHI_LAY_HANG_ADD: 'WEB_BH_DIA_CHI_LAY_HANG_ADD',
  WEB_BH_DIA_CHI_LAY_HANG_EDIT: 'WEB_BH_DIA_CHI_LAY_HANG_EDIT',
  WEB_BH_DIA_CHI_LAY_HANG_DELETE: 'WEB_BH_DIA_CHI_LAY_HANG_DELETE',
} as const
